// @flow
import React from 'react';
import type { YoutubeContent } from 'types/YoutubeContent';
import { getTimeDifference } from 'utils/dateUtils';

type Props = {
  content: YoutubeContent,
  transparent?: boolean,
  onClick: Function
};

const YoutubeCard = (props: Props) => {
  const { backgroundImage, description, likes, share, comments } = props.content;
  const date = props.content.date instanceof Date ? props.content.date : new Date(props.content.date);

  return (
    <a
      href={`https://www.youtube.com/watch?v=${props.content.id}`}
      onClick={props.onClick}
      className="box card card--social"
      title="Voir cette video sur Youtube"
      target="_blank"
      style={{ opacity: props.transparent ? 0.3 : 1 }}
      rel="noopener noreferrer">
      {backgroundImage && (
        <div className="card__thumbnail" style={{ backgroundImage: `url(${backgroundImage})` }}>
          <img src={backgroundImage} alt="" />
          <i className="icon icon-play icon-play--circle" />
        </div>
      )}
      <div className="card__body">
        <p className="card__desc ft-secondary" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className="card__footer ft-h6">
        <div className="card__footer ft-h6">
          <div className="card__stat">
            <span>
              <i className="icon icon-view" />
              {share}
            </span>
            <span>
              <i className="icon icon-like-fb" />
              {likes}
            </span>
            <span>
              <i className="icon icon-coment-fb" />
              {comments}
            </span>
          </div>
          <span className="ft-up">{`${getTimeDifference(new Date(), date)}`}</span>
        </div>
      </div>
      <div className="card__social">
        <span className="label label--blue label--icon">
          <i className="icon icon-youtube " />
        </span>
      </div>
    </a>
  );
};

export default YoutubeCard;
